import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Avatar,Tooltip, Image } from 'antd';
import Header from './Header'
import { MessageMethod } from "./../../helpers"
import { translate } from 'react-i18next'
// import Picker, { SKIN_TONE_MEDIUM_DARK } from 'emoji-picker-react';
import { CloudDownloadOutlined} from '@ant-design/icons';
// import styled from "styled-components";
import { connect } from 'react-redux'
import { get, has } from 'lodash'
import ModalUpload from './ModalUpload'
// import MicRecorder from 'mic-recorder-to-mp3';
import moment from "moment"
//import md5 from 'md5'

// const Mp3Recorder = new MicRecorder({ bitRate: 128 });

// const IconButtonWrapper = styled.div`
//     width: 14px;
//     height: 14px;
//     float: right;
//     transform: rotate(0deg);
//     overflow: hidden;
//     transition: all 0.3s ease-out;
//     transform: ${props => (props.rotation ? `rotate(134deg)` : "")};
// `;




const Chat = ({ t, userInfo, handleChatApi, HistoryMsg, onInputKeydown, setMsg, msg, unreadNotLoaded }) => {

    const { TextArea } = Input
    // const { IconSmile, IconMicrophone, IconPlus } = IconHelper
    // const [rotation, setRotate] = useState(false)
   // const [visible, setVisible] = useState(false)
    const [showModal, setShowModal] = useState({
        show: false,
        dataFile: '',
        preview: '',
        fileList: []
    })
    // const [audio, setAudio] = useState({
    //     isRecording: false,
    //     blobURL: '',
    //     isBlocked: false,
    // })
    // const onEmojiClick = (event, emojiObject) => {
        
    //     setMsg(msg + emojiObject.emoji);
    // };

    const handleChange = (e) => {
        const { value } = e.target;
        setMsg(value)
    }

    // const handleClick = () => {
    //     setRotate(!rotation)

    // };

    // const media = async () => {
    //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //         await navigator.mediaDevices.getUserMedia({ audio: true },
    //             () => {
    //                 console.log('Permission Granted');
    //                 setAudio({ isBlocked: false });
    //             },
    //             () => {
    //                 console.log('Permission Denied');
    //                 setAudio({ isBlocked: true })
    //             },
    //         );
    //     }
    // }

    useEffect(() => {

        //media()

    }, [])

    // const dummyRequest = ({ file, onSuccess }) => {
    //     setTimeout(() => {
    //         onSuccess("OK")
    //     }, 0);
    // }

    const handleCancel = () => {
        setShowModal({ show: false, dataFile: '', fileList: [], preview: "" })
    }

    useEffect(() => {
        onLayoutHeight()
        window.addEventListener('resize', onLayoutHeight)
        updateScroll()
    })

    const updateScroll = () => {
        var element = document.getElementsByClassName("inbox_chat")[0];
        element.scrollTop = element.scrollHeight
    }

    const onLayoutHeight = () => {
        const navCol = document.getElementsByClassName('nav')
        const chatboxCol = document.getElementsByClassName("inbox_chat")
        const inputAreaChat = document.getElementsByClassName("input-area-chat")
        if (navCol[0] && chatboxCol[0]) {
            let nav = navCol[0].offsetHeight
            chatboxCol[0].style.height = `${window.innerHeight - (nav + inputAreaChat[0].offsetHeight + 140)}px`

        }
    }

    // const getBase64 = (file) => {
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         reader.onload = () => resolve(reader.result);
    //         reader.onerror = error => reject(error);
    //     });
    // }


    // const menu = () => {
    //     const props = {
    //         name: 'file',
    //         customRequest: dummyRequest,

    //         async onChange(info) {

    //             if (info.file.status !== 'uploading') {
    //                 console.log(info.file, info.fileList);
    //             }
    //             if (info.file.status === 'done') {
    //                 console.log(`${info.file.name} file uploaded successfully`);
    //                 setShowModal({
    //                     fileList: info.fileList,
    //                     show: true,
    //                     dataFile: info.file,
    //                     preview: await getBase64(info.file.originFileObj)
    //                 })

    //             } else if (info.file.status === 'error') {
    //                 console.log(`${info.file.name} file upload failed.`);
    //             }
    //         },
    //     };
    //     return (
    //         <Menu>
    //             {/* <Menu.ItemGroup title="Create new">
    //                 <Menu.Item><VideoCameraOutlined /> Video message</Menu.Item>
    //                 <Menu.Item><CommentOutlined /> Discussion</Menu.Item>
    //             </Menu.ItemGroup> */}

    //             <Menu.ItemGroup title="Add files form">
    //                 <Menu.Item>
    //                     <Upload {...props}>
    //                         <DesktopOutlined /> Computer
    //                 </Upload>
    //                 </Menu.Item>

    //             </Menu.ItemGroup>
    //         </Menu>
    //     )
    // };

    /**
    * Submit modal form.
    * @param {*} values 
    */
    const onFinish = (values) => {
        console.log('vlaues', values)
        let inputFile = {
            
            name: values["filename"],
            type: values["file"]["type"],
            _id: values["file"]["uid"]
        }
        let imgArr = [];
        let imgObj = Object.assign({}, {
            description: values["description"],
            image_dimensions: {width: 200, height: 200},
            image_preview: values["preview"],
            image_size: values["file"]["size"],
            image_type: values["file"]["type"],
            image_url: values["preview"],
            title: values["file"]["name"],
            title_link: values["preview"],
            title_link_download: true,
            mod: true,
            type: "file"
        })
        imgArr.push(imgObj)
        console.log('inputFile', inputFile)
        console.log('imgArr', imgArr)
        let objFile = Object.assign({}, inputFile)
        let inputObj = {
            msg: "method",
            method: "sendMessage",
            id: "" + new Date().getTime(),
            params: [
              {
                _id: "" + new Date().getTime(),
                rid: localStorage.getItem("chatRoomID"),//localStorage.getItem('chat'),
                attachments: imgArr,
                file: objFile
              },
            ],
        }
        MessageMethod(inputObj);
        setShowModal({ show: false })

    }

    // const start = () => {
    //     if (audio.isBlocked) {
    //         console.log('Permission Denied');
    //     } else {
    //         Mp3Recorder
    //             .start()
    //             .then(() => {
    //                 setAudio({ isRecording: true });
    //             }).catch((e) => console.error(e));
    //     }
    // };

    // const stop = () => {
    //     Mp3Recorder
    //         .stop()
    //         .getMp3()
    //         .then(([buffer, blob]) => {
    //             const blobURL = URL.createObjectURL(blob)
    //             setAudio({ blobURL: blobURL, isRecording: false });
    //         }).catch((e) => console.log(e));
    // };

    // const showAudio = () => {
    //     return (
    //         <>
    //             <Row >
    //                 <Col span={24}>
    //                     <audio src={audio.blobURL} controls="controls" />
    //                     <Button type="primary" shape="circle" onClick={start} disabled={audio.isRecording} icon={<PlayCircleOutlined />} size={"large"} /> &nbsp;
    //                     <Button type="danger" shape="circle" onClick={stop} disabled={!audio.isRecording} icon={<StopOutlined />} size={"large"} />
    //                 </Col>


    //             </Row>



    //         </>
    //     )
    // }

    // const handleVisibleChange = (visible) => {
    //     setVisible(visible)
    // }

    const getAvatar = (item) => {
        return `${window._env_.realtimeRocket}/api/v1/users.getAvatar?userId=${item.u._id}`
    }

    return (
        <>
            <Col xxl={15} xl={14} lg={12} md={12} sm={24} className="reservation-content">
                <Header userInfo={userInfo} handleChatApi={handleChatApi} />
                {/* <div className="calendarCol" />
                <div className="buttonCol" /> */}
                <div className="reservation-room-lists">
                   
                    <div className="box-chat">

                        <div className="inbox_people">
                            <div className="inbox_chat">
                                {/* <Divider><div className="diven-text">October 20, 2020</div></Divider> */}

                                {
                                    Array.isArray(HistoryMsg) && HistoryMsg.map((item, k) => {
                                        return (
                                            <div key={k} className="chat_list">
                                                {item.t !== "au" &&
                                                <div className="chat_people">
                                                    <div className="chat_img"> 
                                                       
                                                        <Avatar src={getAvatar(item)} shape="square" style={{ backgroundColor: '#f56a00', width: "36px", height: "36px" }} > </Avatar>
                                                    </div>
                                                    <div className="chat_ib">
                                                        <div className="box-chat-name"> {item.u.name}
                                                            <span className="box-chat-name-id">@{item.u.username}</span>
                                                            <span className="box-chat-time">{moment(item._updatedAt.$date).format("HH:mm")}</span>
                                                        </div>
                                                      
                                                        <p>{item.msg}</p>
                                                        {Array.isArray(item.attachments) && item.attachments.map((v, i) => {
                                                            return (
                                                                
                                                                <div key={i}>
                                                                    {(has(v,'mod') && v.mod )?
                                                                        <>
                                                                            <p>
                                                                                
                                                                                {/* eslint-disable-next-line */}
                                                                                <a href={`${v.title_link}`} download>{v.title}  &nbsp; <Tooltip title="Download"> <CloudDownloadOutlined /> </Tooltip> </a>
                                                                            </p>
                                                                            <Image src={`${v.image_url}`} width={200} height={200} />
                                                                            <p>{v.description}</p>
                                                                        
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <p>
                                                                    
                                                                                {/* eslint-disable-next-line */}
                                                                                <a href={`${window._env_.realtimeRocket}${v.title_link}`} download>{v.title}  &nbsp; <Tooltip title="Download"> <CloudDownloadOutlined /> </Tooltip> </a>
                                                                            </p>
                                                                            <Image src={`${window._env_.realtimeRocket}${v.image_url}`} width={200} height={200} />
                                                                            <p>{v.description}</p>
                                                                        </>
                                                                    }
                                                                   
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>

                                                 } 
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </div>

                    </div>

                    <div className="input-area-chat">
                        <Row>
                            {/* <Col span={1}> */}

                                {/* <Popover
                                    placement="topLeft"
                                    trigger="click"
                                    content={
                                        <Picker
                                            onEmojiClick={onEmojiClick}
                                            disableAutoFocus={true}
                                            skinTone={SKIN_TONE_MEDIUM_DARK}
                                            groupNames={{ smileys_people: "PEOPLE" }}
                                        />
                                    }

                                > */}
                                    {/* <span>
                                        <IconSmile
                                            style={{
                                                position: "absolute",
                                                left: "10px",
                                                top: "10px",
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItem: "center"
                                            }}
                                        />
                                    </span> */}
                                {/* </Popover> */}


                            {/* </Col> */}
                            <Col span={21}>
                                <TextArea
                                    name="msg"
                                    value={msg}
                                    onChange={e => handleChange(e)}
                                    onKeyPress={onInputKeydown}
                                    onClick={unreadNotLoaded.bind(this)}
                                    style={{

                                        marginTop: "6px"
                                    }} placeholder={t("form_chat.message")} rows={3} bordered={false} />
                            </Col>
                            {/* <Col span={2} className="reservation-content-header-right"> */}
                                {/* <Popover
                                    content={showAudio}
                                    trigger="click"
                                    visible={visible}
                                    onVisibleChange={handleVisibleChange}
                                > */}
                                    {/* <IconMicrophone
                                        style={{
                                            position: "absolute",
                                            left: "0px",
                                            top: "10px",
                                            cursor: 'pointer',

                                        }}
                                    /> */}
                                {/* </Popover> */}


                                {/* <Dropdown overlay={menu()} trigger={['click']} placement="topRight" arrow>

                                    <div className="rolation-icon">
                                        <IconButtonWrapper rotation={rotation} onClick={handleClick}>
                                            <IconPlus />
                                        </IconButtonWrapper>
                                    </div>
                                </Dropdown> */}


                            {/* </Col> */}
                        </Row>






                    </div>
                </div>
            </Col>
            {
                showModal.show && (
                    <ModalUpload
                        title={"Upload file?"}
                        show={showModal.show}
                        dataFile={showModal.dataFile}
                        preview={showModal.preview}
                        handleCancel={handleCancel}
                        onFinish={onFinish}
                       
                    />
                )
            }
        </>
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, 'keycloak', ''),
    authenticated: get(state, 'keycloak.authenticated', false),
    language: get(state, 'language', 'th')
})

export default connect(mapStateToProps, {})(translate()(Chat))
